import * as Nutrient from '@nutrient-sdk/viewer';

export { Nutrient };

export type NutrientToolbarItem = Nutrient.ToolbarItem & {
  isMarkup?: boolean;
  isViewer?: boolean;
  onPress?: () => void;
};

export type DocumentLinkCustomData = {
  annotationType: 'documentLink';
  moduleTypeInstanceId: number;
};

export type NutrientAnnotationTooltipItem = {
  type: 'custom';
  id: string;
  className?: string;
  node: HTMLElement;
};

export type NutrientPagePressEvent = Nutrient.Events.PagePressEvent;

export type NutrientConnectedClients = Nutrient.Instance['connectedClients'];
